// AdminWidgetsSpec.finance-companies.js — 정산/1:1 회사별 위젯 entry (2026-06-08)
//
// 회사별 (PINE/DOT/LNJ): admin_payout_{cc} / admin_consultant_{cc}
// 라벨 형식: "정산 총액 (PINE)" / "1:1 미배정 (DOT)".

import React from 'react';
import { Coins, Users } from 'lucide-react';
import { formatCompactKrw, truncateName, WIDTHS } from './widgetFormat';

function renderPayoutCompany(d) {
  return (
    <span className="flex flex-col items-end max-w-full">
      <span className="text-xl font-black tabular-nums leading-none text-emerald-700 dark:text-emerald-300 whitespace-nowrap">
        {formatCompactKrw(d?.total)}
      </span>
    </span>
  );
}

function renderConsultantCompany(d) {
  if (!d) return '-';
  const count = Number(d.unassignedCount || 0);
  const list = Array.isArray(d.unassignedConsultants) ? d.unassignedConsultants : [];
  if (count === 0) {
    return <span className="text-[10px] text-[var(--text-muted)]">없음</span>;
  }
  return (
    <span className="flex flex-col items-end gap-1">
      <span className="inline-flex items-baseline gap-1">
        <span className="text-3xl font-black tabular-nums leading-none text-violet-700 dark:text-violet-300">{count}</span>
        <span className="text-[11px] font-semibold text-[var(--text-sub)]">명</span>
      </span>
      <span className="flex flex-wrap gap-x-1.5 gap-y-0.5 justify-end items-center mt-0.5">
        {list.slice(0, 4).map((it, i) => (
          <span key={`uc-${i}`} className="text-[10px] text-[var(--text-muted)]">
            {truncateName(it.name || '?', 4)}
          </span>
        ))}
      </span>
    </span>
  );
}

const monthLabel = (m) => {
  if (!m) return '';
  const [, mm] = String(m).split('-');
  if (!mm) return '';
  return `${Number(mm)}월`;
};

const COMPANIES = ['PINE', 'DOT', 'LNJ'];

function payoutEntry(cc) {
  return [`admin_payout_${cc.toLowerCase()}`, {
    Icon: Coins, label: `정산 총액 (${cc})`, width: WIDTHS.WIDE, accent: 'emerald', size: 'S',
    render: renderPayoutCompany,
    monthNavigate: true,
    monthLabel,
    watermarkIcon: Coins,
  }];
}

function consultantEntry(cc) {
  return [`admin_consultant_${cc.toLowerCase()}`, {
    Icon: Users, label: `1:1 미배정 (${cc})`, width: WIDTHS.WIDE, accent: 'violet', size: 'S',
    render: renderConsultantCompany,
    watermarkIcon: Users,
  }];
}

export const FINANCE_COMPANY_ENTRY_BUILDERS = {
  admin_payout: payoutEntry,
  admin_consultant: consultantEntry,
};

export const FINANCE_COMPANY_SPECS = Object.fromEntries([
  ...COMPANIES.map(payoutEntry),
  ...COMPANIES.map(consultantEntry),
]);
